import "./styles.css";
import { Mess, Clx } from "./core";
import * as tags from "./components/tags";
import type { MessConfig, Styles, Breakpoint, Breakpoints, Theme } from "./core/types/mess";

export type { MessConfig, Styles, Breakpoint, Breakpoints, Theme };
export { Clx };
export default Mess;
export const {
  Button,
  Text,
  Image,
  Box,
  Input,
  Label,
  Ul,
  Li,
  Footer,
  Form,
  Span,
  A,
  Select,
  Option,
  Header,
  Main,
  Article,
  Section,
  Aside,
  Nav,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Pre,
  Code,
  Blockquote,
  Hr,
  Br,
  Progress,
  Iframe,
  Canvas,
  Video,
  Audio,
  Figure,
  Figcaption,
  Details,
  Summary,
  Mark,
  Time,
  Meter,
  B,
  I,
  Small,
  Strong,
  Abbr,
  Sub,
  Sup,
} = tags;